module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ashou2-870c723e20ca62aa457a53a15bece67c.jpg";